// @LTG-ID: data-revenue-types
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 04b_SHARED_CONTRACT.md, 08_FEATURES.md#F-008
// @CHANGED: 2026-02 session_002
// @OWNER: web
//
// $1-of-revenue calculator data. Ported verbatim from
// /app/source_reference/Landing Page.html lines 2074-2079.

export const REVENUE_TYPES = [
    {
        key: "recurring",
        label: "Recurring contract",
        desc: "A multi-year subscription, maintenance plan, or retainer that auto-renews.",
        multiplier: 4.2,
        color: "#18B0BD",
        example: "A maintenance plan, an SaaS subscription, a managed-services contract.",
    },
    {
        key: "repeat",
        label: "Repeat customer",
        desc: "A returning customer who buys multiple times a year, but without a contract.",
        multiplier: 2.4,
        color: "#0A2A5E",
        example: "A loyal dental patient, a frequent dining customer, a returning law-firm client.",
    },
    {
        key: "project",
        label: "Project / one-time",
        desc: "A bespoke engagement that pays once. No commitment to come back.",
        multiplier: 1.1,
        color: "#B08D3E",
        example: "A new-construction HVAC install, a one-off implementation, a custom build.",
    },
    {
        key: "transactional",
        label: "Walk-in / transactional",
        desc: "A pure transaction, no relationship, no commitment.",
        multiplier: 0.5,
        color: "#6a7a92",
        example: "A single retail purchase, a one-time consult, a pop-in visit.",
    },
];
